import variables from './styles/variables.module.scss';

/* eslint-disable import/no-anonymous-default-export */
export default {
  pageColorHome: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorPress: {
    color: variables.colorLightPeach,
    mode: 'dark',
    invertColors: false,
  },
  pageColorResidences: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorNeighborhood: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorAmenities: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorPenthouses: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorContact: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorAvailability: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorViews: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorAboutTheArt: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorFlexLiving: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorCollaborators: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
  pageColorLegal: {
    color: variables.colorLightPeach,
    mode: 'light',
    invertColors: false,
  },
};
